import { avatarAnatomy, createMultiStyleConfigHelpers } from '@aloft/toolkit-sui/chakra';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  avatarAnatomy.keys,
);

const outline = definePartsStyle({
  container: {
    borderRadius: '50%',
    borderColor: 'buttonDefault',
    borderWidth: '1px',
    borderStyle: 'solid',
    color: 'buttonDefault',
    backgroundColor: 'transparent',
  },
});

export const avatarStyle = defineMultiStyleConfig({
  variants: { outline },
  sizes: {
    accountAvatar: {
      container: {
        height: '24px',
        width: '24px',
        fontSize: '12px',
      },
    },
  },
});
